import { render } from "./Footer.vue?vue&type=template&id=7e825a34&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=7e825a34&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2335455550/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e825a34"]])

export default __exports__